import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { deleteAPI } from '../api/api';
import { showToast } from '../components/utils/toast';
import { AnalyticsFeatureOperation } from '../interface/analytics';
import { useAnalytics } from './useAnalytics';

const deleteWorkTime = async (
  workTimeId: string,
  deleteOpenLinkedTransaction?: boolean,
): Promise<void> => {
  return deleteAPI(
    `${API_URLS.WORK_TIMES}/${workTimeId}?deleteOpenLinkedTransaction=${deleteOpenLinkedTransaction}`,
  );
};

export const useDeleteWorkTime = (): UseMutationResult<
  void,
  AxiosError<{ message?: string; type?: string }>,
  { id: string; deleteOpenLinkedTransaction?: boolean }
> => {
  const { setIsLoading } = useLoading();
  const { t } = useTranslation();
  const { trackBusinessEvent } = useAnalytics();

  return useMutation({
    mutationFn: ({ id, deleteOpenLinkedTransaction }) =>
      deleteWorkTime(id, deleteOpenLinkedTransaction),
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      trackBusinessEvent(AnalyticsFeatureOperation.WORKTIME_DELETED);
      showToast('success', t('worktime:workTimeDeleted'));
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
